angular.module('leanlaw').directive('llOverviewAccountSummary', [function () {
  return {
    restrict: 'AE',
    template: require("./views/overviewAccountSummary.html"),
    scope: {
      client: "=",
      matter: "=",
      me: "="
    },
    controller: ['$scope', 'singleRequest', function ($scope, singleRequest) {
      $scope.vm = {
        summary: undefined
      };
      activate();
      function activate() {
        $scope.$watchGroup(['client', 'matter'], async () => {
          const {
            client,
            matter
          } = $scope;
          if (matter) {
            if (matter.accounting && !matter.client.billing.billClient) {
              const summary = await loadSummary({
                matterId: matter.id
              });
              // The accounting info isn't summarized in the report so we have to pluck it out of the
              // clients[0] or client[0].matter[0] object
              $scope.vm.summary = summary.clients[0].matters[0].data;
            }
          } else if (client) {
            if (client.accounting) {
              const summary = await loadSummary({
                clientId: client.id
              });
              // The accounting info isn't summarized in the report so we have to pluck it out of the
              // clients[0] or client[0] object
              $scope.vm.summary = summary.clients[0].data;
            }
          }
        });
      }
      function loadSummary(options) {
        const {
          trustEnabled
        } = $scope.me.company.settings;
        $scope.vm.summary = undefined;
        const query = {
          ...options,
          primary: 'clients',
          data: trustEnabled ? 'receivables,trust,lastPayment' : 'receivables,lastPayment',
          zeros: true,
          source: 'client',
          status: 'active'
        };
        return singleRequest.apiCall('summary').getReport(query);
      }
    }]
  };
}]);